export var OrgCostDataGroupBy;
(function (OrgCostDataGroupBy) {
    OrgCostDataGroupBy["ORG_COST_GROUP_BY_ACCOUNT"] = "ACCOUNT";
    OrgCostDataGroupBy["ORG_COST_GROUP_BY_PRODUCT"] = "PRODUCT";
    OrgCostDataGroupBy["ORG_COST_GROUP_BY_USAGE_TYPE"] = "USAGE_TYPE";
    OrgCostDataGroupBy["ORG_COST_GROUP_BY_SOURCE_ACCOUNT"] = "SOURCE_ACCOUNT";
    OrgCostDataGroupBy["ORG_COST_GROUP_BY_CLOUD_PROVIDER"] = "CLOUD_PROVIDER";
    OrgCostDataGroupBy["ORG_COST_GROUP_BY_RESOURCE_TYPE"] = "RESOURCE_TYPE";
    OrgCostDataGroupBy["ORG_COST_GROUP_BY_RESOURCE"] = "RESOURCE";
    OrgCostDataGroupBy["ORG_COST_GROUP_BY_RESOURCE_AND_VAULT"] = "RESOURCE_AND_VAULT";
})(OrgCostDataGroupBy || (OrgCostDataGroupBy = {}));
